import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { fetchApiDataIfNeeded } from '../../../actions/api'
import { PaginationWrapper } from 'shs-pagination'
import { createSelector } from '@reduxjs/toolkit'
import moment from 'moment'
import InputElement from '../../utils/input'
import SHSForm from '../../utils/shs-form'


const selectInstallations = state => state.adminInstallations
const selectInstallPager = state => state.paginator.adminInstallations

const makeInstallations = createSelector(
    [selectInstallations, selectInstallPager],
    (installations, paginator) => {
        if (paginator) {
            return installations
                .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
                .sort((a, b) => {
                    if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                        return 1
                    }
                    return -1
                })
        }
        return []
    }
)

const mapStateToProps = (state) => {
    return {
        installations: makeInstallations(state),
        paginator: selectInstallPager(state),
        configs: state.configs.filter(c => c.field === 'INSTALLATION_STATUS').sort((a, b) => a.order - b.order)
    }
}


const AdminInstallationList = ({ dispatch, installations, paginator, configs }) => {
    const statusOptions = configs?.map(status => {
        return { value: status.id, label: status.display }
    })
    const initialStatus = statusOptions?.find(option => option.label === 'In Process')?.value
    const [activeStatus, setActiveStatus] = useState(initialStatus)

    useEffect(() => {
        if (initialStatus && !activeStatus) {
            setActiveStatus(initialStatus)
        }
    }, [initialStatus, activeStatus])

    useEffect(() => {
        if (activeStatus) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/installations', 'LIST'), { filter: [`status_id|${activeStatus}`] }))
        }
    }, [dispatch, activeStatus])

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('configs', 'LIST', null), { filter: ['field|INSTALLATION_STATUS'] }, true))
    }, [ dispatch ])

    const handlePaginationUpdate = (paginationParams) => {
        console.log(paginationParams)
        const params = {
            ...paginationParams,
            filter: [`status_id|${activeStatus}`]
        }
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/installations', 'LIST'), params))
    }

    const renderInstallRows = (installation, index) => {
        return (
            <tr key={installation.id} className={installation._computed.statusDisplay === 'Needs Attention' ? 'error' : ''}>
                <td className="main">VIN: {installation.vin}</td>
                <td className="main">{installation._computed.accountName}</td>
                <td className="main">{installation._computed.statusDisplay}</td>
                <td className="main">{installation.updatedAt ? moment(installation.updatedAt).format('YYYY-MM-DD HH:mm') : 'N/A'}</td>
                <td className="main">
                    <Link className="btn blue small" to={buildRoutePath(routes.adminInstallationView.path, { installId: installation.id })}>
                        View
                    </Link>
                </td>
            </tr>
        )
    }

    const renderInstallations = () => {
        if (!paginator) {
            return null
        }
        let allInstalls = []
        installations.forEach((installation, index) => {
            allInstalls.push(renderInstallRows(installation, index + 1))
        })
        return (
            <>
                {paginator ? (
                    <PaginationWrapper
                        paginator={paginator}
                        controls={{ search: { enabled: true, collapsed: false } }}
                        countOptions={[10, 25, 50, 100]}
                        callbackFX={handlePaginationUpdate}>
                        {renderStatusDropdown()}
                        { allInstalls.length === 0 ?
                            <p>No installations found.</p>
                            :
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>VIN</th>
                                        <th>Account</th>
                                        <th>Status</th>
                                        <th>Updated</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allInstalls}
                                </tbody>
                            </table>
                        }
                    </PaginationWrapper>
                ) : null
                }
            </>
        )
    }

    const renderStatusDropdown = () => {
        return (
            <SHSForm formClass="d-none">
                <InputElement
                    type="valueSelect"
                    id="status"
                    label={<>&nbsp;</>}
                    default={activeStatus}
                    includeInitialValue={false}
                    onChange={(id, value) => setActiveStatus(value)}
                    options={statusOptions} />
            </SHSForm>
        )
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Installations</h1>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    {renderInstallations()}
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(AdminInstallationList)
